<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="coupon_box flex Flexjustify">
      <div class="coupon_content">
        <div class="flex Flexalign FlexBetween content_top">
          <div class="flex Flexalign">
            <div>注销账号</div>
            <div class="cancel_attention mar_left_20">
              账号注销遇到任何问题，可以随时联系客服
            </div>
          </div>
          <div class="flex Flexalign">
            <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
            <div class="mar_left_10">返回</div>
          </div>
        </div>
        <div class="content">
          <div class="content_top_text mar_top_20">
            尊敬的 小杨同学，您即将开始账号注销流程！
          </div>
          <div class="password_info flex mar_top_20">
            <div class="password_label">手机号：</div>
            <div class="password_label">166****6969</div>
          </div>
          <div class="password_info flex mar_top_20">
            <div class="password_label">
              <span class="require_icon">*</span>验证码：
            </div>
            <div class="password_value">
              <div class="flex Flexalign" v-if="isCodeCancel">
                <el-input v-model="oldPassword" size="large" style="width: 200px; height: 36px" placeholder="请输入验证码" />
                <div class="btn_getCode mar_left_20 cursor_pointer" @click="getCode">
                  {{ textCode }}
                </div>
                <div class="active_text mar_left_20 cursor_pointer" @click="changeIsCodeCancel(false)">账号密码注销 >></div>
              </div>
              <div class="flex Flexalign" v-else>
                <el-input v-model="oldPassword" size="large" style="width: 200px; height: 36px" placeholder="请输入密码" />
                <div class="active_text mar_left_20 cursor_pointer" @click="changeIsCodeCancel(true)">手机号注销 >></div>
              </div>
              <slider class="mar_top_15" v-if="isCodeCancel"></slider>
            </div>
          </div>
          <div class="password_info flex mar_top_20">
            <div class="password_label">
              <span class="require_icon">*</span>注销原因：
            </div>
            <el-input v-model="oldPassword" size="large" style="width: 220px; height: 36px"
              placeholder="请详细描述注销原因，200字以内" type="textarea" />
          </div>
          <div class="user_notice">用户须知</div>
          <div class="account_info mar_top_15">
            您当前的账号为 小杨同学，注销后：
          </div>
          <div class="account_attention">
            1、账号绑定的手机号、邮箱、昵称将清空且无法恢复
          </div>
          <div class="account_attention">2、账号绑定的第三方账号将解除绑定</div>
          <div class="account_attention">
            3、会员权益、付费课程学习权益、未过期优
          </div>
          <div class="mar_top_20 flex Flexalign">
            <el-checkbox v-model="isAgree" label="" size="large" />
            <div class="mar_left_10 ft_weight_600 cursor_pointer">请阅读并同意<span class="active_text"
                @click="showAgreement">《账号注销协议》</span></div>
          </div>
          <div class="btn_save mar_top_30">申请注销</div>
        </div>
      </div>
      <agreement ref="agreement"></agreement>
    </div>
  </moe-page>
</template>

<script>
import slider from "@/components/slider/index";
import agreement from '@/components/popup/agreement.vue';
export default {
  name: "GjkcH5CancelAccount",

  components: {
    slider,
    agreement,
  },
  data() {
    return {
      oldPassword: "",
      textCode: "获取验证码",
      disabled: false,
      isCodeCancel: true,
      isAgree: false,
    };
  },

  mounted() { },

  methods: {
    getCode() {
      if (this.disabled) return;
      this.disabled = true;
      let n = 60;
      this.textCode = "重新发送 " + n + "s";
      const run = setInterval(() => {
        n = n - 1;
        if (n < 0) {
          clearInterval(run);
        }
        this.textCode = "重新发送 " + n + "s";
        if (this.textCode < "重新发送 " + 0 + "s") {
          this.disabled = false;
          this.textCode = "重新获取";
        }
      }, 1000);
    },
    changeIsCodeCancel(flag) {
      this.isCodeCancel = flag;
    },
    showAgreement() {
      this.$refs.agreement.agreementShow = true;
    }
  },
};
</script>
<style lang="scss" scoped>
.coupon_box {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight);
  background: #f3f3f3;

  .coupon_content {
    margin-top: 20px;
    box-sizing: border-box;
    width: $pageMainWidth;
    height: 900px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .content_top {
      font-size: 18px;
      color: #13d6aa;
      border-bottom: 1px solid rgba(20, 20, 20, 0.1);
      padding-bottom: 15px;

      .cancel_attention {
        font-size: 14px;
        color: #999999;
      }

      .back_icon {
        width: 24px;
        height: 24px;
      }
    }

    .content {
      .content_top_text {
        color: #2d2d2d;
        font-weight: 600;
      }

      .password_info {
        .password_label {
          line-height: 36px;
          width: 120px;
          font-size: 18px;
          color: #333333;

          .require_icon {
            color: red;
          }
        }

        .password_value {
          .strength_box {
            width: 220px;

            .strength_one {
              width: 67px;
              height: 34px;
              background: #ebebeb;
              line-height: 34px;
              text-align: center;
              color: #333333;
              font-weight: 600;
            }
          }

          .password_attention {
            font-size: 14px;
            color: #ff6619;
          }

          .btn_getCode {
            width: 127px;
            height: 36px;
            background: #edeced;
            border-radius: 5px;
            border: 1px solid #d8d8d8;
            box-sizing: border-box;
            line-height: 36px;
            text-align: center;
            color: #2d2d2d;
          }

          .active_text {
            color: #13d6aa;
          }
        }
      }

      .user_notice {
        font-weight: bold;
        font-size: 18px;
        color: #111111;
        margin-top: 40px;
      }

      .account_info {
        font-size: 16px;
        color: #2d2d2d;
      }

      .account_attention {
        line-height: 38px;
      }

      :deep(.el-checkbox.el-checkbox--large .el-checkbox__inner) {
        width: 20px;
        height: 20px;
      }

      :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-color: #00d498;
      }

      :deep(.el-checkbox__inner::after) {
        border: 2px solid #fff;
        border-left: 0;
        border-top: 0;
        left: 6px;
        top: 1px;
        height: 10px;
        width: 5px;
      }

      .active_text {
        color: #13D6AA;
      }

      .btn_save {
        width: 124px;
        height: 36px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-radius: 18px;
        text-align: center;
        line-height: 36px;
        color: #ffffff;
      }
    }
  }
}
</style>